var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSofer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.29 115.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f313d;}.cls-2{fill:#2f333d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.59,115.48c-13.14-.07-26.19-1-38.92-4.61-.62-.18-1.23-.37-1.84-.58-4.44-1.59-7-4.39-6.82-9.46A49.87,49.87,0,0,1,1.09,90.34C2.73,83.85,7,79.55,12.74,76.45a103.41,103.41,0,0,1,15-6.46,2.13,2.13,0,0,1,2.37.59,25.34,25.34,0,0,0,32,1.72,2.19,2.19,0,0,0,.57-.41c1.82-2.58,4-2.2,6.54-1.08,4.66,2.07,9.46,3.79,13.89,6.43,7.17,4.26,10.48,10.68,11,18.74.15,2.11.05,4.24,0,6.35-.1,4.08-2.49,6.45-6.07,7.81a73.18,73.18,0,0,1-16.26,3.78A161.67,161.67,0,0,1,47.59,115.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.61,35.61a11.43,11.43,0,0,1-2.93-.89,60.18,60.18,0,0,0-19.79-4.63,52.72,52.72,0,0,0-19.38,3.12c-2.05.71-4.05,1.57-6.11,2.24A2.77,2.77,0,0,1,20.27,35a2.7,2.7,0,0,1-.47-3.28c1.8-3.2,1.78-6.77,2.31-10.23.59-3.84,1.16-7.68,3.6-10.91C28.55,6.78,32.79,5.46,37,4.13a28.08,28.08,0,0,1,3.44-.76,4.84,4.84,0,0,0,3.61-1.95C45.58-.74,49.47-.33,50.89,2a2.24,2.24,0,0,0,1.77,1.16,31.66,31.66,0,0,1,13.6,5c3.86,2.69,4.89,6.88,5.67,11.14.56,3.11,1,6.26,1.43,9.39a16.59,16.59,0,0,0,1.23,3.09C75.35,33.92,74.24,35.63,71.61,35.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.55,70C39.09,69.64,33,65.8,28.31,59.44a38.93,38.93,0,0,1-7.17-18.17c-.15-1.09.07-1.55,1.24-1.74,4.32-.67,4.26-.7,5.15,3.42,1.56,7.21,4.69,13.57,10.78,18a15.24,15.24,0,0,0,20-1.66c5.22-5.19,7.9-11.59,9-18.72.2-1.34.59-1.8,1.88-1.32a3.51,3.51,0,0,0,.87.11c3.35.31,3.55.35,2.93,3.58-1.94,10.06-6.27,18.69-15.41,24.19A21.14,21.14,0,0,1,46.55,70Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSofer);
export default __webpack_public_path__ + "static/media/IconSofer.e437d31d2a2f88f72b228e092e17181e.svg";
export { ForwardRef as ReactComponent };